<template>
  <div class="w-full">
    <algolia-autocomplete :navigation-event-ids="navigationEventIds" :should-render-icon-only="shouldRenderIconOnly" />
  </div>
</template>
<script>
import AlgoliaAutocomplete from './AlgoliaAutocomplete.vue'
import { TradeShowApi } from '@/api'

export default {
  name: 'TheSearchField',
  components: { AlgoliaAutocomplete },
  props: {
    shouldRenderIconOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      navigationEventIds: undefined
    }
  },
  async mounted() {
    const { features } = await TradeShowApi.getTradeShowEnabledFeatures()

    this.navigationEventIds = features.navigation.event_ids
  }
}
</script>
